/* eslint-disable */
import messages from "./messages";

export const loginPatt = /^(?:[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)(?!.)/;

export const namePatt = /^(?:[A-Za-z0-9!#$%&"();:,<>@'*+\/\[\]\\=?^_`{|}~-]*)(?!.)/;

export const selectOptions = {
  domain: [
    {
      id: "basf",
      label: "@basf.com",
    },
    {
      id: "sa",
      label: "@sm-analytics.com",
    },
  ],
};

export const addUserFormConfig = [
  {
    id: "name",
    name: messages.name,
    type: "text",
    selectOptions: [],
    selectId: "",
    maxLength: 50,
  }
];

export const INITIAL_FORM_STATE = {
  department: 1,
  requiredFields: {
    name: "",
    isDeleted: false,
  },
  errors: {
    name: false,
  },
  showErrorMessage: false,
  dirty: false,
};

export const ROWS_PER_PAGE = 14;

export const INITIAL_SORTING_ID = "name";

export const ASCENDING_ORDER = "asc";

export const DESCENDING_ORDER = "desc";

export const MAX_NAME_LENGTH = 50;

export const MAX_SURNAME_LENGTH = 100;

export const MAX_LOGIN_LENGTH = 64;
